module.exports = __webpack_public_path__ + "static/img/Freewheel-AM-Selected.92aaa4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Freewheel-AM-Selected.png
// module id = 607
// module chunks = 0